import { FC, memo, ReactElement, useEffect } from "react";

import Menu from "widgets/Menu";
import RealtimeProvider from "widgets/RealtimeProvider";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { getCurrentUserRequest } from "store/slices/authSlice";

import { TOKEN_KEY } from "utils/constants";
import { CookieHelper } from "utils/helpers";

type PropsType = {
  children?: ReactElement;
};

const LayoutMain: FC<PropsType> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const token = CookieHelper.getCookie(TOKEN_KEY);

  useEffect(() => {
    if (token && !user) {
      dispatch(getCurrentUserRequest());
    }
  }, [token, user, dispatch]);

  return (
    <div className="layout-main">
      <RealtimeProvider />

      <Menu className="layout-main__menu" />

      <div className="layout-main__content">{children}</div>
    </div>
  );
};

export default memo(LayoutMain);
